var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin || _vm.checkAccess('statements'))?_c('div',[_c('report-list-page',{attrs:{"page-title":"Statement","page-icon":"mdi-cash-multiple","descending":true,"headers":_vm.headers,"state-end-point":"statement.statements","actions":_vm.actions,"show-component":_vm.showComponent,"item-key":"id"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }